"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeAssignment = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const DSSL001_Detail_Child_1 = require("../../DSS/DSSL001/DSSL001_Detail_Child");
const account_1 = require("../../base/account");
const HomeSubmission_1 = require("./HomeSubmission");
const DSTL001_List_Child_1 = require("./component/DSTL001_List_Child");
const HomeAssignmentStyled = styled_components_1.default.div `
	.home-list-003 {
		height: 100%;
	}
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	&.home_assignment {
		height: 100%;
	}
	.wrap_submission {
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 8px;
		justify-content: center;
		align-items: center;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	&.home_assignment {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 100%;
		gap: 20px;
		flex: 1;
		overflow: hidden;

		.task-board-container {
			overflow: hidden;
		}

		.assignment-table {
			width: 100%;
		}
	}

	.wrap_submission {
		text-align: center;
		display: flex;
		flex-direction: column;
		gap: 8px;
		justify-content: center;
		align-items: center;
	}

	.title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b2-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b2-font-size, 18px);
		line-height: var(--b2-line-height, 36px);
		letter-spacing: var(--b2-letter-spacing, -0.02em);
		font-weight: var(--b2-font-weight, 700);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
`;
exports.HomeAssignment = react_1.default.memo(({ isTeacher, isTest }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [selectItem, setSelectItem] = (0, react_1.useState)();
    const [selectName, setSelectName] = (0, react_1.useState)();
    const member_id = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const handlerSelectItem = (id, name) => {
        setSelectItem(id);
        setSelectName(name);
    };
    return (react_1.default.createElement(HomeAssignmentStyled, { "$isMobile": isMobile, className: "home_assignment" },
        selectItem && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "line" }),
            react_1.default.createElement("div", { className: "wrap_submission" }, isTeacher ? (react_1.default.createElement(HomeSubmission_1.SubmissionContainer, { test_id: selectItem })) : (react_1.default.createElement(DSSL001_Detail_Child_1.SubmitResult, { selectName: selectName, isHome: true, test_id: selectItem, member_id: member_id }))))),
        react_1.default.createElement(DSTL001_List_Child_1.AssignmentTable, { isTeacher: isTeacher, isTest: isTest, isHome: true, selectItem: selectItem, handlerSelectItem: handlerSelectItem })));
});
